import Vue from "vue";
import { EventBus } from "../event-bus.js";

import isEqual from "lodash/isEqual";

const roundPercent = Symbol("roundPercent");
const whichTransitionEvent = Symbol("whichTransitionEvent");

var fps = 60;
var now;
var then = Date.now();
var interval = 1000 / fps;
var delta;

const viewClass = new (class View {
    constructor() {
        // console.log(`${this.constructor.name}:init`)

        this.class = {
            reveal: "js-reveal",
            revealVisible: "is-visible",
        };

        // Correct transitionend event name
        this.transitionEnd = this[whichTransitionEvent]() ? this[whichTransitionEvent]() : "transitionsEnd";

        this.pos, (this.lastPos = {});

        this.items = {};
        this.activeItems = [];

        // Define observer
        let $target;
        this.observer = new IntersectionObserver(($observables) => {
            this.lastPos = {};
            $observables.forEach(($observable) => {
                $target = $observable.target;
                if ($observable.isIntersecting) {
                    this.activeItems.push($target.id);
                } else {
                    this.activeItems = this.activeItems.filter((i) => i !== $target.id);
                }
            });
        });

        // Window events
        window.addEventListener("load", () => {
            // TODO: REMOVE TIMEOUT
            setTimeout(() => {
                // Define horizontal scroll container
                this.container = document.querySelector(".l-wrapper__inner");

                if (!this.container) return;

                // Scroll in page
                this.scroll = {
                    x: window.pageYOffset,
                    y: this.container.scrollLeft,
                };

                // Set sizes
                this.setSizes();

                // RAF Loop
                //
                this.gameLoop();
            }, 1000);
        });
    }

    gameLoop() {
        this.CPUSaver();
        // window.addEventListener("resize", this.setSizes.bind(this));

        // window.requestAnimationFrame(this.loop.bind(this));
        window.requestAnimationFrame(this.gameLoop.bind(this));
    }
    CPUSaver() {
        // code inpirted from > https://gist.github.com/elundmark/38d3596a883521cb24f5
        // the difference is that I used timelapse istead of date, so instead of 1000 interval, we only need 1 / fps
        // const fps = 50;
        // const interval = 1000 / fps; // replaced
        // const delta = now - then;
        //   console.log("CPUSaver before");

        now = Date.now();
        delta = now - then;

        if (delta > interval) {
            // this.animations.rotations.animation.isAnimationStarted ? this.animateRotation() : null;
            // console.log("CPUSaver", then, now);
            this.loop();
            // Just `then = now` is not enough.
            // Lets say we set fps at 10 which means
            // each frame must take 100ms
            // Now frame executes in 16ms (60fps) so
            // the loop iterates 7 times (16*7 = 112ms) until
            // delta > interval === true
            // Eventually this lowers down the FPS as
            // 112*10 = 1120ms (NOT 1000ms).
            // So we have to get rid of that extra 12ms
            // by subtracting delta (112) % interval (100).
            // Hope that makes sense.
            then = now - (delta % interval);
        }
    }

    setSizes() {
        // console.log(`${this.constructor.name}:setSizes`)

        this.W = {
            w: window.innerWidth,
            h: window.innerHeight,
        };

        this.doc = {
            h: window.document.documentElement.scrollHeight,
            w: this.container.scrollWidth,
        };
    }

    observeItem(id, item) {
        // console.log(`${this.constructor.name}:observeItem`)
        this.items[id] = item;
        this.observer.observe(this.items[id].element);
    }

    unobserveItem(id) {
        // console.log(`${this.constructor.name}:unobserveItem`, id)

        // patching previous work. Avoid an error
        this.items[id]
            ? (this.observer.unobserve(this.items[id].element),
              delete this.items[id],
              (this.activeItems = this.activeItems.filter((i) => i !== id)))
            : null;
    }

    loop() {
        // console.log(`${this.constructor.name}:loop`);

        if (!this.container) {
            this.container = document.querySelector(".l-wrapper__inner");
        }

        this.pos = {
            top: window.pageYOffset,
            right: this.container.scrollLeft + this.W.w,
            bottom: window.pageYOffset + this.W.h,
            left: this.container.scrollLeft,
        };

        isEqual(this.pos, this.lastPos) ? null : (this.lastPos = this.pos);

        let i, inType, eventType;
        this.activeItems.forEach((id) => {
            i = this.items[id];

            inType = this.getInType(i);

            if (typeof i.handler === "function") {
                i.handler({
                    type: eventType,
                    percent: {
                        inView: inType.percentInView,
                        top: inType.percentTop,
                        left: inType.percentLeft,
                        center: {
                            x: inType.percentCenterX,
                            y: inType.percentCenterY,
                        },
                        scroll: {
                            x: this[roundPercent](this.pos.top / (this.doc.h - this.W.h)),
                            y: this[roundPercent](this.pos.left / (this.doc.w - this.W.w)),
                        },
                    },
                    scroll: {
                        x: this.pos.top - this.scroll.x,
                        y: this.pos.left - this.scroll.y,
                    },
                    target: i.element,
                });
            }

            if (i.reveal === true) {
                i.element.classList.add(this.class.revealVisible);

                if (i.delay) {
                    setTimeout(() => {
                        this.revealEnd(i);
                    }, i.delay * 1000);
                } else {
                    i.element.addEventListener(this.transitionEnd, this.revealEnd(i));
                }
            }
        });

        this.scroll = {
            x: this.pos.top,
            y: this.pos.left,
        };

        // requestAnimationFrame(this.loop.bind(this)); // loop is managed from CPUSaver()
    }

    revealEnd(i) {
        // console.log(`${this.constructor.name}:revealEnd`, i)

        i.element.classList.remove(this.class.reveal);
        i.element.classList.remove(this.class.revealVisible);
        i.element.removeEventListener(this.transitionEnd, this.revealEnd);
    }

    getInType(i) {
        let rect = i.element.getBoundingClientRect();
        let elementTop = rect.top + this.pos.top;
        let elementLeft = rect.left + this.pos.left;
        let elementBottom = elementTop + rect.height;
        let topIn = elementTop > this.pos.top && elementTop < this.pos.bottom;
        let bottomIn = elementBottom > this.pos.top && elementBottom < this.pos.bottom;
        let percentInView =
            topIn || bottomIn
                ? ((bottomIn ? elementBottom : this.pos.bottom) - (topIn ? elementTop : this.pos.top)) / rect.height
                : 0;
        let centerPercentY = (elementTop - this.pos.top + rect.height / 2) / this.W.h;
        let centerPercentX = (elementLeft - this.pos.left + rect.width / 2) / this.W.w;
        let zeroPoint = {
            top: this.pos.top - rect.height,
            left: this.pos.left - rect.width,
        };
        let topPercent = (elementTop - zeroPoint.top) / (this.pos.bottom - zeroPoint.top);
        let leftPercent = (elementLeft - zeroPoint.left) / (this.pos.right - zeroPoint.left);

        return {
            percentInView: this[roundPercent](percentInView),
            percentCenterX: this[roundPercent](centerPercentX),
            percentCenterY: this[roundPercent](centerPercentY),
            percentTop: this[roundPercent](topPercent),
            percentLeft: this[roundPercent](leftPercent),
            rect: rect,
        };
    }

    [roundPercent](v) {
        return ((v * 1000) | 0) / 1000;
    }

    /**
     * Use the correct `transitionend` event
     * @return {string} The prefixed event name
     */
    [whichTransitionEvent]() {
        const el = document.createElement("div");
        const transitions = {
            OTransition: "oTransitionEnd",
            MozTransition: "transitionend",
            WebkitTransition: "webkitTransitionEnd",
            transition: "transitionend",
        };

        for (let t in transitions) {
            if (el.style[t] !== undefined) {
                return transitions[t];
            }
        }
    }
})();

let itemIndex = 0;
export const view = Vue.directive("view", {
    inserted: function ($el, bind) {
        let id = $el.id || "view-id-" + itemIndex++;
        let item = viewClass.items[id] || { element: $el, classes: {}, reveal: false, rect: {} };

        if (bind.modifiers.reveal) {
            item.reveal = true;
            item.element.classList.add(viewClass.class.reveal);
        }

        if (typeof bind.value === "number") {
            item.delay = bind.value;
        } else if (typeof bind.value === "function") {
            item.handler = bind.value;
        } else if (typeof bind.value === "object") {
            if (typeof bind.value.handler === "function") {
                item.handler = bind.value.handler;
            }
            if (typeof bind.value.delay === "number") {
                item.delay = bind.value.delay;
            }
        }

        $el.id = id;

        EventBus.$on("loader-complete", () => {
            viewClass.observeItem(id, item);
        });
    },
    unbind: function ($el) {
        viewClass.unobserveItem($el.id);
    },
});
